import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import CalendarService from '../../services/Calendar.service';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import '!style-loader!css-loader!./MonthViewEventTemplate.css';
import { EventCodes } from '../../../common/TelemetryConstants';
import { useDidMountEffect } from '../../hooks/useDidMountEffect';
export function MonthViewEventTemplate(calEvent) {
    let _componentName = 'MonthlyViewComponent';
    let event = calEvent.event;
    let isUserUpdated = event.customProperties
        ? event.customProperties.isUserUpdated
        : false;
    let eventCategory = event.customProperties
        ? event.customProperties.eventCategory
        : '';
    let trimmedDate = "";
    if (eventCategory == "talentforecast") {
        trimmedDate = event.start.substring(0, 10); // 'YYYY-MM-DD'
    }
    let freeHoursVal = !!event.customProperties.freeHours
        ? event.customProperties.freeHours
        : 0;
    let flexHoursVal = !!event.customProperties.flexHours
        ? event.customProperties.flexHours
        : 0;
    const [freeHours, setFreeHours] = useState(freeHoursVal);
    const [flexHours, setFlexHours] = useState(flexHoursVal);
    const [isSaving, setSaving] = useState(false);
    const [newlyUpdated, setNewlyUpdated] = useState(false);
    let delayedForecastUpsertSubject = new Subject();
    let postObservable = delayedForecastUpsertSubject.pipe(debounceTime(200));
    //#region Inject services
    let calendarService = CalendarService.getSingleton();
    const loggerService = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.FxpLoggerService);
    const userInfo = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.UserInfoService);
    let curUserAlias = userInfo.getCurrentUser();
    //#endregion
    //#region Handlers
    const selectAllText = (event) => event.target.select();
    //helper to clamp free/flex input
    let clampHrs = (value, min = 0, max = 8) => {
        let val = Number(value);
        if (!isNaN(val)) {
            if (val > 8)
                return '8';
            if (val < 0)
                return '0';
            return `${val}`;
        }
        else {
            return '0';
        }
    };
    let updateHours = () => {
        delayedForecastUpsertSubject.next(true);
        setSaving(true);
        // isSaving.current = true;
    };
    //#endregion
    //#region Styles
    const defaultBorderStyle = {
        borderWidth: '0px',
        borderBottomWidth: '1px',
        borderStyle: 'inset',
        borderColor: isUserUpdated ? 'rgb(0, 183, 195)' : 'black',
        boxShadow: 'none',
    };
    const errorBorderStyle = {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'rgb(255 0 0 / 50%)',
        boxShadow: '0 0 5px rgb(255 0 0 / 80%)',
    };
    const commonInputStyles = {
        width: '2em',
        height: '1.3em',
        background: 'white',
        outline: 'none',
        margin: '0vw 0.2vw',
        borderRadius: '12%',
        textAlign: 'center',
    };
    const [hoursInputStyle, setInputStyle] = useState(Object.assign(Object.assign({}, commonInputStyles), defaultBorderStyle));
    //#endregion
    useEffect(() => {
        let postSubscription = postObservable.subscribe({
            next: (_) => __awaiter(this, void 0, void 0, function* () {
                let response = yield calendarService.postFreeFlexHours(curUserAlias, trimmedDate, Number(freeHours), Number(flexHours));
                setSaving(false);
                // isSaving.current = false;
                if (response == false) {
                    setInputStyle(Object.assign(Object.assign({}, commonInputStyles), errorBorderStyle));
                }
                else {
                    setInputStyle(Object.assign(Object.assign({}, commonInputStyles), defaultBorderStyle));
                    let propertyBag = loggerService.createPropertyBag();
                    propertyBag.addToBag("cesalias", curUserAlias);
                    propertyBag.addToBag("savedDate", trimmedDate);
                    propertyBag.addToBag("freeHours", freeHours);
                    propertyBag.addToBag("flexHours", flexHours);
                    loggerService.logEvent(_componentName, EventCodes.Ev0001, propertyBag);
                    // Set glimmer icon
                    setNewlyUpdated(true);
                }
            }),
            error: _ => {
                setSaving(false);
                console.log('Error in upserting talent forecast');
            },
        });
        return () => {
            postSubscription.unsubscribe();
        };
    }, [calEvent, freeHours, flexHours, newlyUpdated]);
    useDidMountEffect(() => {
        updateHours();
    }, [freeHours, flexHours]);
    switch (eventCategory) {
        case 'talentforecast':
            return (React.createElement("div", { className: `freeFlexContainer ${isSaving ? (isUserUpdated ? 'freeFlexContainerAnimeGreen' : 'freeFlexContainerAnimeGray') : ''} ${isSaving ? 'freeFlexContainerAnime' : ''}` },
                newlyUpdated && React.createElement("span", { className: "ra-lib-icon ra-lib-icon--glimmer inline-glimmer" }),
                "Free",
                React.createElement("input", { className: "freeFlexInlineInput", style: hoursInputStyle, value: freeHours, type: "number", min: "0", max: "8", step: "1", onChange: event => {
                        setFreeHours(+event.target.value);
                    }, onFocus: selectAllText }),
                "\u00A0 Flex",
                React.createElement("input", { className: "freeFlexInlineInput", type: "number", style: hoursInputStyle, value: flexHours, min: "0", max: "8", step: "1", onChange: event => {
                        setFlexHours(+event.target.value);
                    }, onFocus: selectAllText })));
            break;
        case 'outlook':
        case 'project':
        case 'msvacation':
        case 'publicholiday':
        case 'nonproject':
        default:
            return React.createElement(React.Fragment, null, event.title);
            break;
    }
}
//# sourceMappingURL=MonthViewEventTemplate.js.map